import { Component, OnInit, OnDestroy, AfterViewInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MailingFilter } from '../../models/mailing-filter';
import { HttpClient } from '@angular/common/http';
import { BusAuctionFilterService } from '../../../home/services/bus-auction-filter.service';
import { DataTableDirective } from 'angular-datatables';
import { environment } from '../../../../../environments/environment';
import { AuctionFilter } from '../../../home/models/auction-filter';
import { LoggingService } from '../../../../services/logging.service';

const apiServer = environment.apiServer;
declare var $: any;

class SearchFilter {
  search: string;
}

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}


@Component({
  selector: 'app-home-main-modal-customer',
  templateUrl: './home-main-modal-customer.component.html',
  styleUrls: ['./home-main-modal-customer.component.sass']
})
export class HomeMainModalCustomerComponent implements OnInit, OnDestroy, AfterViewInit {

  private subs: any[] = [];

  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;
  @ViewChildren('nameInput') nameInputModel: QueryList<any>;

  dt: DataTables.Api;
  // modelCustomerFilter: CustomerFilter = new CustomerFilter();
  // modelAuctionFilter: AuctionFilter = new AuctionFilter();
  modelCustomerFilter: AuctionFilter = new AuctionFilter();
  modelAuctionFilter: AuctionFilter = new AuctionFilter();
  dtOptionsCustomers: DataTables.Settings = {};
  dataSetCustomer: any;
  checkedCustomer: number[];
  searchFilter: SearchFilter = new SearchFilter();

  constructor(private http: HttpClient, private bus: BusAuctionFilterService, private loggingService: LoggingService) {
    this.checkedCustomer = [];
  }

  onFieldChange() {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.MailingList.HomeMainModalCustomerComponent.onFieldChange', null, 'Field change started');
      
      this.dt.ajax.reload();
      
      this.loggingService.logFinish(_xid, 'App.Components.MailingList.HomeMainModalCustomerComponent.onFieldChange', null, 'Field change completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.MailingList.HomeMainModalCustomerComponent.onFieldChange', _error, null, 'Field change failed');
      throw _error;
    }
  }

  ngOnInit() {

    this.subs.push(this.bus.currentClearModalFilter$.subscribe(key => {

      if (key === 'contractor') {
        this.nameInputModel.forEach(function (item) {
          item.nativeElement.checked = false;
        });
        this.checkedCustomer = [];
        this.onAuctionFilter();
      }

    }));

    const that = this;
    this.dtOptionsCustomers = {
      pagingType: 'full_numbers',
      pageLength: 250,
      serverSide: true,
      processing: true,
      autoWidth: false,
      dom: 'tip',
      order: [1],
      language: {
        emptyTable: 'Нет данных',
        info: 'Отображено с _START_ по _END_ из _TOTAL_ записей',
        infoEmpty: 'Отображено с 0 по 0 из 0 записей',
        infoFiltered: '(отфильтровано из _MAX_ записей)',
        infoPostFix: '',
        thousands: ',',
        lengthMenu: 'Показывать по _MENU_ записей',
        loadingRecords: 'Загрузка ...',
        processing: 'Обработка ...',
        search: 'Поиск:',
        zeroRecords: 'Нет совпадающих значений для поиска',
        paginate: {
          first: 'Первая',
          last: 'Последняя',
          next: 'След.',
          previous: 'Пред.'
        },
        aria: {
          sortAscending: ': activate to sort column ascending',
          sortDescending: ': activate to sort column descending'
        }
      },
      ajax: (dataTablesParameters: any, callback) => {
         dataTablesParameters.search = this.searchFilter.search;

        that.http.post<DataTablesResponse>(`${apiServer}/getClientShortList`, dataTablesParameters, {})
          .subscribe(resp => {
            that.dataSetCustomer = resp.data;
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
          });
      },
      columnDefs: [
        {
          orderable: false,
          className: 'select-checkbox',
          targets: 0
        },
      ]
    };
  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  onSelectedRow(event, value) {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.MailingList.HomeMainModalCustomerComponent.onSelectedRow', null, 'Row selection started');
      
      if (event.target.checked) {
        this.checkedCustomer.push(value);
      } else {
        for (let i = 0; i < this.checkedCustomer.length; i++) {
          if (this.checkedCustomer[i] === value) {
            this.checkedCustomer.splice(i, 1);
          }
        }
      }
      
      this.loggingService.logFinish(_xid, 'App.Components.MailingList.HomeMainModalCustomerComponent.onSelectedRow', null, 'Row selection completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.MailingList.HomeMainModalCustomerComponent.onSelectedRow', _error, null, 'Row selection failed');
      throw _error;
    }
  }

  onSelectingRows(event) {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.MailingList.HomeMainModalCustomerComponent.onSelectingRows', null, 'Selecting all rows started');
      
      const that = this;

      this.nameInputModel.forEach(function (item) {
        item.nativeElement.checked = event.target.checked;

        if (event.target.checked) {
          that.checkedCustomer.push(item.nativeElement.value);
        } else {
          for (let i = 0; i < that.checkedCustomer.length; i++) {
            if (that.checkedCustomer[i] === item.nativeElement.value) {
              that.checkedCustomer.splice(i, 1);
            }
          }
        }
      });
      
      this.loggingService.logFinish(_xid, 'App.Components.MailingList.HomeMainModalCustomerComponent.onSelectingRows', null, 'Selecting all rows completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.MailingList.HomeMainModalCustomerComponent.onSelectingRows', _error, null, 'Selecting all rows failed');
      throw _error;
    }
  }

  ngAfterViewInit(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      this.dt = dtInstance;
    });
  }

  onAuctionFilter() {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.MailingList.HomeMainModalCustomerComponent.onAuctionFilter', null, 'Auction filter started');
      
      this.modelAuctionFilter.contractor = this.checkedCustomer.join(',');
      this.bus.changeFilter(this.modelAuctionFilter);
      
      this.loggingService.logFinish(_xid, 'App.Components.MailingList.HomeMainModalCustomerComponent.onAuctionFilter', null, 'Auction filter completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.MailingList.HomeMainModalCustomerComponent.onAuctionFilter', _error, null, 'Auction filter failed');
      throw _error;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/mailing-list/component/home-main-modal-customer/home-main-modal-customer.component.ts